<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>
<main class="container py-4">

  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h4 class="fw-bold mb-0">Jurisdictions</h4>
      <div class="text-muted small">Manage supported countries and global fallback settings</div>
    </div>

    <div class="d-flex gap-2">
      <a class="btn btn-outline-secondary btn-sm" routerLink="/admin/compliance">
        Back
      </a>
      <button class="btn btn-primary btn-sm" (click)="createNew()">
        New Jurisdiction
      </button>
    </div>
  </div>

  <div class="card shadow-sm border-0 mb-4">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label small">Search</label>
          <input
            class="form-control"
            [(ngModel)]="filter.search"
            placeholder="Code or name" />
        </div>

        <div class="col-md-3">
          <label class="form-label small">Active</label>
          <select class="form-select" [(ngModel)]="filter.isActive">
            <option value="">All</option>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
        </div>

        <div class="col-md-3">
          <label class="form-label small">Global Fallback</label>
          <select class="form-select" [(ngModel)]="filter.isGlobalFallback">
            <option value="">All</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>

        <div class="col-md-2">
          <label class="form-label small">Page Size</label>
          <select class="form-select" [(ngModel)]="filter.pageSize">
            <option [ngValue]="">Default</option>
            <option [ngValue]="10">10</option>
            <option [ngValue]="20">20</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
          </select>
        </div>
      </div>

      <div class="mt-3 d-flex gap-2">
        <button class="btn btn-primary btn-sm" (click)="load()">Apply</button>
        <button class="btn btn-outline-secondary btn-sm" (click)="resetFilters()">Reset</button>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="text-center py-4">
    <div class="spinner-border"></div>
  </div>

  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
  </div>

  <div *ngIf="!loading && !items.length" class="alert alert-light border">
    No jurisdictions found.
  </div>

  <div *ngIf="items.length && !loading" class="card shadow-sm border-0">
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th>Code</th>
            <th>Name</th>
            <th>Regulatory Zone</th>
            <th>Active</th>
            <th>Global Fallback</th>
            <th>Updated</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of items">
            <td class="fw-semibold">{{ item.code }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.regulatoryZone || '-' }}</td>

            <td>
              <span class="badge" [ngClass]="statusBadgeClass(item.isActive)">
                {{ asYesNo(item.isActive) }}
              </span>
            </td>

            <td>
              <span class="badge" [ngClass]="statusBadgeClass(item.isGlobalFallback)">
                {{ asYesNo(item.isGlobalFallback) }}
              </span>
            </td>

            <td>{{ item.lastUpdatedAt | date:'medium' }}</td>

            <td class="text-end">
              <button class="btn btn-sm btn-outline-primary" (click)="edit(item)">
                Edit
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <app-pagination *ngIf="meta && meta.totalRows > 0" [url]='url' [counts]='meta!' (refresh)="onPageLoad($event)"></app-pagination>
    </div>
  </div>

  <app-footer></app-footer>
</main>
</div>